import React, {useState} from 'react';
import {NavLink} from "react-router-dom";

function Navigation(props) {
    const [selected, setSelected] = useState(1);
    return (
        <div className="navTabs mt-24">
            <ul className="level1">
                <li className = {window.location.pathname == '/employee' ? "selected" : ""} onClick={()=> setSelected(1)}>
                    <NavLink to="/employee">Employees</NavLink>
                </li>
                <li className = {window.location.pathname == '/packages' ? "selected" : ""} onClick={()=> setSelected(2)}>
                    <NavLink to="/packages">Packages</NavLink>
                </li>
                {/*<li  className = {window.location.pathname == '/promos' ? "selected" : ""} onClick={()=> setSelected(3)}>*/}
                {/*    <NavLink to="/promos">Promos</NavLink>*/}
                {/*</li>*/}
            </ul>
        </div>
    );
}

export default Navigation;